import { render, staticRenderFns } from "./stayOrderModel.vue?vue&type=template&id=105b0fdd&scoped=true&"
import script from "./stayOrderModel.vue?vue&type=script&lang=js&"
export * from "./stayOrderModel.vue?vue&type=script&lang=js&"
import style0 from "./stayOrderModel.vue?vue&type=style&index=0&id=105b0fdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b0fdd",
  null
  
)

export default component.exports